import { useEffect, useState } from 'react';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from "react-scroll";
import { useNavbar } from '../Navbar Context/NavbarContextAPI';

const Navbar = () => {
    const { isMenuOpen, toggleNavbar } = useNavbar();
    const [isScrolled, setIsScrolled] = useState(false);

    // Smooth scroll listener for the collapse effect
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Lock background scroll when mobile menu is open
    useEffect(() => {
        if (isMenuOpen && window.innerWidth < 640) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isMenuOpen]);

    return (
        // Outer Wrapper: Pure Glass effect with dynamic shadow when scrolling
        <div className={`sticky top-0 z-[9999] w-full bg-white/[0.03] backdrop-blur-xl border-b border-white/[0.08] transition-all duration-500 ease-in-out ${isScrolled ? "shadow-lg shadow-black/20" : ""}`}> 
            <div className="navbar container mx-auto w-full transition-all duration-500 ease-in-out">
                <div className={`navbarContent w-full flex flex-col md:flex-row md:justify-evenly lg:justify-between items-center transition-all duration-500 ease-in-out ${isScrolled ? "p-3" : "p-5"}`}>
                    
                    {/* Header Row */}
                    <div className="logo w-full md:w-auto flex justify-between items-center">
                        <Link to="home" className='text-white phs:text-[1.3rem] text-xl cursor-pointer tracking-wider font-extrabold hover:text-red-400 transition-colors duration-300'>
                            <h1>&lt; Karan's Portfolio /&gt;</h1>
                        </Link>
                        {/* Dynamic rotation animation on the hamburger / close toggle icon */}
                        <button className='text-white sm:hidden text-2xl p-1 active:scale-90 transition-all duration-300 ease-in-out transform hover:rotate-90' onClick={toggleNavbar}>
                            <FontAwesomeIcon icon={isMenuOpen ? faXmark : faBars}></FontAwesomeIcon>
                        </button>
                    </div>
                    
                    {/* Phone Drawer: Re-imagined into a highly attractive, floating glass card block */}
                    <div className={`links absolute top-[105%] left-0 right-0 mx-4 bg-black/85 backdrop-blur-2xl p-6 z-[9999] rounded-2xl border border-white/[0.1] shadow-[0_20px_50px_rgba(0,0,0,0.5)] transition-all duration-500 cubic-bezier(0.4, 0, 0.2, 1) md:static md:h-auto md:w-auto md:bg-transparent md:backdrop-blur-none md:p-0 md:border-none md:shadow-none md:mx-0 ${
                        isMenuOpen 
                        ? "translate-y-0 opacity-100 visibility-visible scale-100" 
                        : "phs:-translate-y-4 phs:opacity-0 phs:invisible phs:scale-95 md:translate-y-0 md:opacity-100 md:visibility-visible md:scale-100"
                    }`}>
                        {/* Staggered text presentation on mobile using custom transitions */}
                        <ul className={`text-white flex flex-col sm:flex-row sm:space-x-8 lg:text-[0.75rem] font-medium tracking-wide uppercase text-sm phs:space-y-4 transition-all duration-700 delay-100 ${isMenuOpen ? "phs:translate-y-0 phs:opacity-100" : "phs:translate-y-2 phs:opacity-0 md:translate-y-0 md:opacity-100"}`}>
                            <li>
                                <Link className='transition-all duration-300 hover:text-red-400 cursor-pointer relative block py-2 sm:py-0 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[2px] after:bg-red-400 hover:after:w-full after:transition-all after:duration-300'
                                onClick={() => { if (window.innerWidth < 640) toggleNavbar(); }}
                                 to="home" smooth={true} duration={500}>Home</Link>
                            </li>
                            <li>
                                <Link className='transition-all duration-300 hover:text-red-400 cursor-pointer relative block py-2 sm:py-0 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[2px] after:bg-red-400 hover:after:w-full after:transition-all after:duration-300' 
                                onClick={() => { if (window.innerWidth < 640) toggleNavbar(); }}
                                 to="educationandexperience" smooth={true} duration={500}>Education and Experience</Link>
                            </li>
                            <li>
                                <Link className='transition-all duration-300 hover:text-red-400 cursor-pointer relative block py-2 sm:py-0 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[2px] after:bg-red-400 hover:after:w-full after:transition-all after:duration-300'
                                onClick={() => { if (window.innerWidth < 640) toggleNavbar(); }}
                                 to="portfolio" smooth={true} duration={500}>Portfolio</Link>
                            </li>
                            <li>
                                <Link className='transition-all duration-300 hover:text-red-400 cursor-pointer relative block py-2 sm:py-0 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[2px] after:bg-red-400 hover:after:w-full after:transition-all after:duration-300'
                                onClick={() => { if (window.innerWidth < 640) toggleNavbar(); }}
                                 to="skills" smooth={true} duration={500}>Skills</Link>
                            </li>
                            <li>
                                <Link className='transition-all duration-300 hover:text-red-400 cursor-pointer relative block py-2 sm:py-0 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[2px] after:bg-red-400 hover:after:w-full after:transition-all after:duration-300'
                                onClick={() => { if (window.innerWidth < 640) toggleNavbar(); }}
                                to="contact" smooth={true} duration={500}>Contact</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar;